import { Alert, Button, Space, Tag, Typography } from 'antd';
import { useStartupChecks } from '../../hooks/useStartupChecks';

const { Text } = Typography;

export function StartupChecksBanner() {
  const { checks, overallStatus, isLoading, lastCheckedAt, recheck } = useStartupChecks();

  if (isLoading && checks.length === 0) {
    return (
      <Alert
        type="info"
        showIcon
        message="Startup checks"
        description="Running initial system checks..."
        style={{ marginBottom: 16 }}
      />
    );
  }

  const type = overallStatus === 'ok' ? 'success' : overallStatus === 'warning' ? 'warning' : 'error';
  const summary =
    overallStatus === 'ok'
      ? 'All startup checks passed'
      : overallStatus === 'warning'
        ? 'Startup checks found warnings'
        : 'Startup checks found problems';

  return (
    <Alert
      type={type}
      showIcon
      style={{ marginBottom: 16 }}
      message={
        <Space>
          <span>{summary}</span>
          <Button size="small" onClick={() => void recheck()}>
            Recheck
          </Button>
          {lastCheckedAt && <Text type="secondary">Last check: {new Date(lastCheckedAt).toLocaleTimeString()}</Text>}
        </Space>
      }
      description={
        <Space direction="vertical" size={4} style={{ width: '100%' }}>
          {checks.map((check) => (
            <Space key={check.key} align="start" style={{ justifyContent: 'space-between', width: '100%' }}>
              <Space>
                <Tag color={check.status === 'ok' ? 'green' : check.status === 'warning' ? 'orange' : 'red'}>
                  {check.status.toUpperCase()}
                </Tag>
                <Text strong>{check.title}</Text>
              </Space>
              <Text type="secondary">{check.details}</Text>
            </Space>
          ))}
        </Space>
      }
    />
  );
}

